export class EmailDeposit {
  login: string;
  bank: string;
  agency: string;
  account: string;
  source: string;
  favored: string;
  value: string;
  described_value: string;
  total_withdrawal_checked: string;
  comments: string;
  destination: string;
}
